import { useEffect, useState } from "react";

export function useIsConnected() {
  // Initialize state based on the browser's current online status.
  const [isConnected, setIsConnected] = useState(navigator.onLine);

  useEffect(() => {
    // Event handler to update state when the browser goes online.
    const handleOnline = () => setIsConnected(true);
    // Event handler to update state when the browser goes offline.
    const handleOffline = () => setIsConnected(false);

    // Add event listeners for online and offline events.
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup the event listeners on unmount.
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isConnected;
}